export default __webpack_public_path__ + "static/media/spam-label.049325eb.svg";